import useUnassignInboundEmail from '@/api/mutations/inbound-emails/useUnassignInboundEmail';
import { UnassignInboundEmailMutation } from '@/gql/graphql';
import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { createOptimisticMutationOptions } from './createOptimisticMutation';
import {
  applyDetailOptimisticUnassign,
  applyOptimisticUnassign,
} from './optimisticUpdates';

const useOptimisticUnassignInboundEmail = (
  options?: UseMutationOptions<
    UnassignInboundEmailMutation,
    unknown,
    { inboundEmailId: string }
  >
) => {
  const queryClient = useQueryClient();

  const optimistic = createOptimisticMutationOptions(
    queryClient,
    {
      applyToInbox: (data, vars) => applyOptimisticUnassign(data, vars),
      applyToDetail: (data) => applyDetailOptimisticUnassign(data),
      tracksUnreadCount: false,
    },
    options
  );

  return useUnassignInboundEmail({ ...options, ...optimistic });
};

export default useOptimisticUnassignInboundEmail;
